import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation, Trans } from "react-i18next";
import { FiAlertTriangle, FiX } from "react-icons/fi";
import styles from "./ConfirmLeaveModal.module.scss";

  const ConfirmLeaveModal = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onCancel();
      if (e.key === "Enter") onConfirm();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onConfirm, onCancel]);

  return createPortal(
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button className={`${styles.closeBtn} has-tooltip`} onClick={onCancel} type="button" aria-label={t("common.close")}>
          <FiX />
        </button>

        <div className={styles.iconWrap}>
          <FiAlertTriangle className={styles.icon} />
        </div>

        <h2 className={styles.title}>{t("confirm_leave.title")}</h2>
        <p className={styles.message}>
          <Trans i18nKey="confirm_leave.message_html" components={{ br: <br />, strong: <strong /> }} />
        </p>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.btnCancel}
            onClick={onCancel}
          >
            {t("confirm_leave.stay")}
          </button>
          <button
            type="button"
            className={styles.btnConfirm}
            onClick={onConfirm}
          >
            {t("confirm_leave.leave")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmLeaveModal;
